module.exports = __webpack_public_path__ + "img/sort-icon.4a74ed4c.svg";